<template>
  <div
    v-if="loadedPage"
    class="cashback-list">

    <div
      class="the-list">
      <md-table>
        <md-table-toolbar class="list-toolbar">
          <div>
            <h1 v-if="cashbacksTotal" class="md-title">{{ cashbacksTotal }} Cashbacks</h1>
            <h1 v-else class="md-title">{{ cashbacks.length >= 50 ? '> 50' : cashbacks.length }} Cashbacks</h1>
          </div>
          <InputField
            v-model="search"
            placeholder="Find cashback..."
            trailingIcon="magnifyingGlass"
            clickableTrailingIcon
            @trailingIconClick="findEntities()"
            @enterKey="findEntities()"/>

          <div
            class="column-picker"
            @focus="campaignOptions = true"
            @blur="campaignOptions = false">
            <button
              class="btn btn-activate"
              @click="campaignOptions = !campaignOptions">
              Campaigns
            </button>
            <div
              v-show="campaignOptions"
              class="column-options">
              <InputField
                v-model="campSearch"
                placeholder="Find campaign..."
                class="column-search"
                @input="findAdminPVCampaign()"/>
              <div
                class="column-option"
                v-for="(campaign, index) in campaignPicker"
                :class="{ 'active-column-option': campaign.active }"
                :key="`column-option-${index}-${campaign.name}`"
                @click="activateCampaignFilter(campaign)">
                <span v-if="admin">{{ campaign.company?.name }} - </span>
                {{ campaign.name }}
              </div>
            </div>
          </div>
          <div
            class="column-picker"
            @focus="activationOptions = true"
            @blur="activationOptions = false">
            <button
              class="btn btn-activate"
              @click="activationOptions = !activationOptions">
              Activations
            </button>
            <div
              v-show="activationOptions"
              class="column-options">
              <InputField
                v-model="actSearch"
                placeholder="Find activation..."
                class="column-search"
                @input="findAdminPVActivation()"/>
              <div
                class="column-option"
                v-for="(activation, index) in activationPicker"
                :class="{ 'active-column-option': activation.active }"
                :key="`column-option-${index}-${activation.name}`"
                @click="activateActivationFilter(activation)">
                <span v-if="admin">{{ activation.company.name }} - </span>
                {{ activation.market }} - {{ activation.name }}
              </div>
            </div>
          </div>
          <div
            class="column-picker"
            @focus="statusOptions = true"
            @blur="statusOptions = false">
            <button
              class="btn btn-activate"
              @click="statusOptions = !statusOptions">
              Status
            </button>
            <div
              v-show="statusOptions"
              class="column-options">
              <div
                class="column-option"
                v-for="status in statuses"
                :class="{ 'active-column-option': status.active }"
                :key="`column-option-${status.id}`"
                @click="activateStatusFilter(status)">
                {{ status.name }}
              </div>
            </div>
          </div>
          <div
            class="column-picker"
            @focus="filterOptions = true"
            @blur="filterOptions = false">
            <button
              class="btn btn-activate"
              @click="filterOptions = !filterOptions">
              Filters
            </button>
            <div
              v-show="filterOptions"
              class="column-options">
              <div
                class="column-option"
                v-for="filter in filters"
                :class="{ 'active-column-option': filter.active }"
                :key="`column-option-${filter.id}`">
                <div @click="filter.func ? filter.func() : filter.active = !filter.active">
                  {{ filter.name }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="column-picker"
            @focus="columnOptions = true"
            @blur="columnOptions = false">
            <button
              class="btn btn-activate"
              @click="columnOptions = !columnOptions">
              Columns
            </button>
            <div
              v-show="columnOptions"
              class="column-options">
              <div
                class="column-option"
                v-for="column in actualColumns"
                :class="{ 'active-column-option': column.active }"
                :key="`column-option-${column.title}`"
                @click="column.active = !column.active">
                {{ column.title }}
              </div>
            </div>
          </div>
          <div
            class="column-picker"
            @focus="statOptions = true"
            @blur="statOptions = false">
            <button
              class="btn btn-activate"
              :class="{ 'btn-disabled': !campaignId && !activationId }"
              @click="statOptions = !statOptions">
              Functions
            </button>
            <div
              v-show="statOptions"
              class="column-options">
              <div class="column-option">
                NOTE: the search is not applied to the campaign details!
              </div>
              <div class="column-option">
                <button
                  class="btn btn-activate"
                  :class="{ 'btn-disabled': !campaignId }"
                  @click="openCampaignDetails()">Campaign details</button>
              </div>
              <!--<div class="column-option">
                <button class="btn btn-activate" @click="showListModal = true">Get List</button>
              </div>
              <div v-if="admin" class="column-option">
                <button class="btn btn-activate" @click="show3rdPartyListModal = true">Get 3rd party List</button>
              </div>
              <div class="column-option">
                <button class="btn btn-activate" @click="showStatsModal = true">Get Stats</button>
              </div>
              <div class="column-option">
                <button class="btn btn-activate" @click="showCTAModal = true">Get CTA's</button>
              </div>
              <div class="column-option">
                <button class="btn btn-activate" @click="communicationModal = true">Create Communication</button>
              </div>-->
            </div>
          </div>
        </md-table-toolbar>
        <!--style="position: sticky; top: 0; z-index: 1;" dosnt work..-->
        <md-table-row>
          <md-table-head
            v-for="column in activeColumns"
            :key="`title-${column.title}`">
            {{ column.title }}
            <span
              v-if="column.sort"
              class="clickable"
              :style="`color: ${activeSort == column.db ? 'black' : 'grey'}`"
              @click="toggleSort(column)">{{ activeSort == column.db ? activeSortType : 'sort' }}</span>
          </md-table-head>
        </md-table-row>
        <md-table-row
          v-for="cashback in cashbacks"
          :key="cashback._id">
          <md-table-cell
            v-for="column in activeColumns"
            :key="`row-${column.title}`">
            <CashbackProgress
              v-if="column.db == 'progress'"
              :cashback="cashback"
              @clicked="openCashbackDetails(cashback)"/>
            <div v-else-if="!column.exclude">
              {{ getValue(cashback, column) }}
              <span v-if="column.edit && havePerm([perms.participations.write])" @click="openEditModal(cashback, column.db)">
                <svg style="vertical-align: top; cursor: pointer;" width="12px" height="12px" viewBox="0 0 24 24" id="_24x24_On_Light_Edit" data-name="24x24/On Light/Edit" xmlns="http://www.w3.org/2000/svg">
                  <rect id="view-box" width="24" height="24" fill="none"/>
                  <path id="Shape" d="M.75,17.5A.751.751,0,0,1,0,16.75V12.569a.755.755,0,0,1,.22-.53L11.461.8a2.72,2.72,0,0,1,3.848,0L16.7,2.191a2.72,2.72,0,0,1,0,3.848L5.462,17.28a.747.747,0,0,1-.531.22ZM1.5,12.879V16h3.12l7.91-7.91L9.41,4.97ZM13.591,7.03l2.051-2.051a1.223,1.223,0,0,0,0-1.727L14.249,1.858a1.222,1.222,0,0,0-1.727,0L10.47,3.91Z" transform="translate(3.25 3.25)" fill="#141124"/>
                </svg>
              </span>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <!--<md-table-row>-->
      <div class="pagination">
        <button
          :class="{ 'btn-disabled': first == 0 }"
          class="btn btn-activate"
          @click="paginate(-1)">
          Previous
        </button>
        <div style="align-self: center;">Page {{ first == 0 ? '1' : (first / number)+1 }}</div>
        <button
          :class="{ 'btn-disabled': cashbacks.length < 50 }"
          class="btn btn-activate"
          @click="paginate(1)">
          Next
        </button>
      </div>
    </div>

    <modal
      v-if="showListModal"
      size="xlarge"
      modalType="fullscreen"
      @close="showListModal = false;"
      :header="{ closeButton: true, textPosition: 'center', text: 'Get List' }">
      <slot>
        <h3>Filters</h3>
        <md-datepicker
          v-model="statCreatedStart">
          <label>Created Start</label>
        </md-datepicker>
        <md-datepicker
          v-model="statCreatedEnd">
          <label>Created End</label>
        </md-datepicker>
        <md-field>
          <label for="cta_done">cta_done?</label>
          <md-select
            v-model="ctaDone">
            <md-option value="all">Both</md-option>
            <md-option :value="true">cta_done == true</md-option>
            <md-option :value="false">cta_done == false</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label for="administrated">administrated?</label>
          <md-select
            v-model="administrated">
            <md-option value="all">Both</md-option>
            <md-option :value="true">administrated == true</md-option>
            <md-option :value="false">administrated == false</md-option>
          </md-select>
        </md-field>
        <h3>Change selection</h3>
        <md-field>
          <label for="administrated">Set Administrated</label>
          <md-select
            v-model="setAdministrated">
            <md-option value="all">Set all</md-option>
            <md-option value="cta_done">Set all (cta_done == true)</md-option>
            <md-option :value="false">Don't set</md-option>
          </md-select>
        </md-field>
        <div>
          <button class="btn btn-activate" @click="getList()">Download List</button>
          <button class="btn btn-transparent" @click="showListModal = false">Close</button>
        </div>
      </slot>
    </modal>

    <modal
      v-if="show3rdPartyListModal"
      size="xlarge"
      modalType="fullscreen"
      @close="show3rdPartyListModal = false;"
      :header="{ closeButton: true, textPosition: 'center', text: 'Get 3rd party List' }">
      <slot>
        <div style="text-align: left;">
          <h3>Important!</h3>
          <p>When you download this list, the following will happen:</p>
          <ul>
            <li>All cashbacks will be cta_done == true</li>
            <li>All cashbacks will be administrated == false</li>
            <li>The cashbacks you get will be set to administrated = true</li>
          </ul>
          <p>All of this means that the next time you click this button, you will only get cashbacks that are administrated == false, ie repeat the steps above</p>
        </div>
        <div>
          <button class="btn btn-activate" @click="get3rdPartyList()">Download List</button>
          <button class="btn btn-transparent" @click="show3rdPartyListModal = false">Close</button>
        </div>
      </slot>
    </modal>

    <modal
      v-if="dateModal"
      size="xlarge"
      modalType="fullscreen"
      @close="dateModal = false;"
      :header="{ closeButton: true, textPosition: 'center', text: 'Set filter for created-date' }">
      <slot>
        <md-datepicker
          v-model="createdStart">
          <label>Created Start</label>
        </md-datepicker>
        <md-datepicker
          v-model="createdEnd">
          <label>Created End</label>
        </md-datepicker>
        <div>
          <button class="btn btn-activate" @click="applyDateFilter()">Apply</button>
        </div>
      </slot>
    </modal>

    <modal
      v-if="campaignDetailsModal"
      size="xlarge"
      modalType="fullscreen"
      @close="campaignDetailsModal = false;"
      :header="{ closeButton: true, textPosition: 'center', text: 'Campaign details' }">
      <slot>
        <div>Total <b>{{ formatNumber(campaign.cashback_total_amount) }} {{ campaign.cashback_currency }}</b></div>
        <div>Batch <b>{{ formatNumber(campaign.cashback_batch_amount) }} {{ campaign.cashback_currency }}</b></div>
        <div>Cost <b>{{ formatNumber(campaign.cashbackCost) }} {{ campaign.cashback_currency }}</b></div>
        <table class="simple-table" style="margin: 10px 0">
          <thead>
            <tr>
              <th>Type</th>
              <th>Number</th>
              <th>Sum</th>
              <th>Batch Balance</th>
              <th>Total Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Success</td>
              <td>{{ campaign.cashbackSuccessLength }}</td>
              <td><b>{{ formatNumber(campaign.cashbackSuccessSum) }} {{ campaign.cashback_currency }}</b></td>
              <td><b>{{ formatNumber(campaign.cashback_batch_amount - campaign.cashbackSuccessSum) }} {{ campaign.cashback_currency }}</b></td>
              <td><b>{{ formatNumber(campaign.cashback_total_amount - campaign.cashbackSuccessSum) }} {{ campaign.cashback_currency }}</b></td>
            </tr>
            <tr>
              <td>Done</td>
              <td>{{ campaign.cashbackDoneLength }}</td>
              <td><b>{{ formatNumber(campaign.cashbackDoneSum) }} {{ campaign.cashback_currency }}</b></td>
              <td><b>{{ formatNumber(campaign.cashback_batch_amount - campaign.cashbackDoneSum) }} {{ campaign.cashback_currency }}</b></td>
              <td><b>{{ formatNumber(campaign.cashback_total_amount - campaign.cashbackDoneSum) }} {{ campaign.cashback_currency }}</b></td>
            </tr>
          </tbody>
        </table>

        <CampaignCharts :campaign="campaign" :admin="admin"/>
      </slot>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import moment from 'moment-timezone';
import { debounce as _debounce } from 'lodash-es';
import InputField from '../InputField/InputField';
import CashbackProgress from '../CashbackProgress/CashbackProgress';
import CampaignCharts from '../CampaignCharts/CampaignCharts.vue';
import ListMixin from '../../../mixins/ListMixin.vue';
import RolesMixin from '../../../mixins/RolesMixin.vue';

export default {
  name: "CashbackList",
  components: {
    InputField,
    CashbackProgress,
    CampaignCharts,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ListMixin, RolesMixin],
  created() {
    this.findEntities = _debounce(() => {
      this.$store.dispatch(`pvCashbacks/find${this.userType}PVCashbacks`, {
        key: this.key,
        search: this.search,
        filters: this.getActiveFilters(),
        campaignId: this.campaignId,
        activationId: this.activationId,
        createdStart: this.createdStart/1000,
        createdEnd: this.createdEnd/1000 + 3600*24,
        first: this.first,
        number: this.number,
        sort: this.theSort,
      }).then(() => {
        this.loadedCashbacks = true;
      });
    }, 300);
  },
  mounted() {
    this.setActiveSearch();
    this.setActiveColumns();
    this.setActiveStatus();
    this.setActiveFilters();
    this.setCampaignId();
    this.setActivationId();
    this.setPagination();

    this.findEntities();
    this.findAdminPVCampaign();
    this.findAdminPVActivation();
  },
  computed: {
    ...mapGetters('pvCashbacks', ['cashbacks', 'cashbacksTotal']),
    ...mapGetters('pvCampaigns', ['campaign', 'campaigns']),
    ...mapGetters('pvActivations', ['activations']),
    loadedPage() {
      return this.loadedActivations && this.loadedCashbacks && this.loadedRoles;
    },
    minDate() {
      return this.campaign.balanceTable?.labels?.[0] || '';
    },
    maxDate() {
      const labels = this.campaign.balanceTable?.labels;
      return labels ? labels[labels.length - 1] : '';
    },
    slopeTotal() {
      if (!this.campaign.balanceTable) return null;
      return this.getSlope(
        this.campaign.balanceTable.datasets[0].data,
        this.campaign.balanceTable.labels,
        this.slopeStart,
        this.slopeEnd
      );
    },
  },
  data() {
    return {
      statusOptions: false,
      filterOptions: false,
      columnOptions: false,
      campaignOptions: false,
      activationOptions: false,
      statOptions: false,
      dateModal: false,
      campaignDetailsModal: false,
      key: '',
      search: '',
      campSearch: '',
      actSearch: '',
      actFilters: { cashback_step: true },
      retSearch: '',
      statuses: [
        { id: 'cashbacksuccess', name: 'Cashback success', active: false, filter: { responsecode: '111' }},
        { id: 'cashbackdone', name: 'Cashback done', active: false, filter: { responsecode: '000' }},
        { id: 'blocked', name: 'Blocked', active: false, filter: { responsecode: '152' }},
        { id: 'canceled', name: 'Canceled', active: false, filter: { responsecode: '159' }},
        /*{ id: 'received', name: 'Recevied', active: false, filter: { responsecode: '101' }},
        { id: 'generalerror', name: 'General error', active: false, filter: { responsecode: '511' }},
        { id: 'error', name: 'Error message', active: false, filter: { responsecode: '521' }},
        { id: 'registered', name: 'Registered', active: false, filter: { responsecode: '105' }},
        { id: 'registermail', name: 'Register mail', active: false, filter: { responsecode: '107' }},
        { id: 'approved', name: 'Approved', active: false, filter: { responsecode: '150' }},
        { id: 'registerlink', name: 'Register link', active: false, filter: { responsecode: '108' }},
        { id: 'registergeneralerror', name: 'Register general error', active: false, filter: { responsecode: '711' }},
        { id: 'registererrormessage', name: 'Register error message', active: false, filter: { responsecode: '721' }},
        { id: 'cashbackgeneralerror', name: 'Cashback general error', active: false, filter: { responsecode: '911' }},
        { id: 'cashbackerrormessage', name: 'Cashback error message', active: false, filter: { responsecode: '921' }}*/
      ],
      filters: [
        { id: 'datemodal', name: 'Date', active: true,
          func: () => {
            this.dateModal = !this.dateModal;
          }
        },
        /*{ id: 'cashbacksuccess', name: 'Cashback success', active: false, filter: { success: true }},
        { id: 'cashbackdone', name: 'Cashback done', active: false, filter: { done: true } },*/
        { id: 'issue', name: 'Issue', active: false, filter: {
          $or: [
            { responsecode: '152' },
            { responsecode: '159' },
            { responsecode: '511' },
            { responsecode: '521' },
            { responsecode: '711' },
            { responsecode: '721' },
            { responsecode: '911' },
            { responsecode: '921' },
          ]
        }},
      ],
      campaignId: '',
      activationId: '',
      first: 0,
      number: 50,
      columns: [
        { title: 'Campaign name', active: false, db: 'campaign.name', type: 'string' },
        { title: 'Activation name', active: true, db: 'activation.name', type: 'string' },
        { title: 'Cashback id', active: false, db: '_id', type: 'string' },
        // { title: 'Name', active: true, db: 'name+last_name', type: 'string' },
        { title: 'Phone Nr', active: false, db: 'receipt.phone_nr', type: 'string' },
        { title: 'Email', active: false, db: 'receipt.email', type: 'string' },
        { title: 'Amount', active: true, db: 'amount', type: 'number-floor' },
        { title: 'Currency', active: true, db: 'currency', type: 'string' },
        { title: 'Progress', active: true, db: 'progress' },
        { title: 'Response code', active: false, db: 'responsecode', type: 'string' },
        { title: 'Response text', active: false, db: 'responsetext', type: 'string' },
        { title: 'Reference', active: false, db: 'reference', type: 'string' },
        { title: 'Transid', active: false, db: 'transid', type: 'string' },
        { title: 'Estimate', active: false, db: 'estimate', type: 'string' },
        { title: 'Cost', active: false, db: 'cost', type: 'number-floor' },
        { title: 'Receipt date', active: true, db: 'receipt.receipt_date', type: 'string' },
        { title: 'Created at', active: true, type: 'unix', db: 'created_at', sort: true },
      ],
      theSort: { created_at: -1 },
      activeSort: 'created_at',
      activeSortType: 'descending',
      detailedInfoModal: false,
      detailedCashback: {},
      editId: '',
      editValue: '',
      editKey: '',
      editModal: false,
      showListModal: false,
      show3rdPartyListModal: false,
      ctaDone: 'all',
      statCreatedStart: 1672578061000,
      statCreatedEnd: (new moment()).valueOf(),
      createdStart: 1672578061000,
      createdEnd: (new moment()).valueOf(),
      administrated: 'all',
      setAdministrated: false,
      showStatsModal: false,
      won: 'all',
      showCTAModal: false,
      communicationModal: false,
      newCommunicationName: '',
      cashbackStore: '',
      cashbackStoreTop: 20,
      slopeStart: null,
      slopeEnd: null,
    };
  },
  watch: {
    loadedRoles(newVal) {
      if (newVal) {
        this.setPerms('buttons', [this.perms.participations.write]);
      }
    },
  },
  methods: {
    getSlope(data, labels, startDate, endDate) {
      // Find indices for the selected dates
      const startIdx = labels.indexOf(startDate);
      const endIdx = labels.indexOf(endDate);

      if (startIdx === -1 || endIdx === -1 || endIdx <= startIdx) return null;

      const deltaY = data[endIdx] - data[startIdx];
      const deltaX = endIdx - startIdx; // days

      return deltaY / deltaX;
    },
    async openCampaignDetails() {
      if (!this.campaignId) {
        return;
      } else if (this.campaignId == this.campaign._id) {
        this.campaignDetailsModal = true;
        return;
      }

      await this.$store.dispatch(`pvCampaigns/get${this.userType}PVCampaign`, {
        entityId: this.campaignId,
      });

      this.campaignDetailsModal = true;
    },
    openCashbackDetails(cashback) {
      this.detailedCashback = cashback;
      // this.detailedInfoModal = true;
    }, 
    openEditModal(cashback, db) {
      this.editId = cashback._id;
      this.editValue = cashback[db];
      this.editKey = db;
      this.editModal = true;
    },
    // TODO: add the search in the lists below
    getList() {
      axios.get(`/api/pv/${this.userApi}/activations/${this.activationId}/cashbacks/csv`
        +`?createdStart=${this.statCreatedStart/1000}&createdEnd=${this.statCreatedEnd/1000}&setAdministrated=${this.setAdministrated}&administrated=${this.administrated}&ctaDone=${this.ctaDone}`)
      .then((response) => {
        this.downloadResFile(response);
      });
    },
    get3rdPartyList() {
      axios.get(`/api/pv/${this.userApi}/activations/${this.activationId}/cashbacks/3rdparty/csv`
        +`?setAdministrated=cta_done&administrated=false&ctaDone=true`)
      .then((response) => {
        this.downloadResFile(response);
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./CashbackList.scss";
</style>
